import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  const thoughts = [{
    thought: 'El pensamiento',
    fear: 'El miedo que esconde',
    isHeader: true
  }, {
    thought: '"¿Y si mañana no rindo?"',
    fear: 'Miedo a fallarle a quienes dependen de ti',
    isHeader: false
  }, {
    thought: '"¿Cómo pago la luz?"',
    fear: 'La ansiedad financiera golpea más fuerte en la oscuridad',
    isHeader: false
  }, {
    thought: '"¿Estoy perdiendo mi salud?"',
    fear: 'Las hormonas de la menopausia avivan el miedo como leña seca',
    isHeader: false
  }];
  return <section className="py-20 px-4 md:px-8 bg-cream-100 text-navy-900 pt-[30px] pb-[30px]" data-id="element-231">
      <div className="max-w-4xl mx-auto" data-id="element-232">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-233">
          <span className="text-4xl mb-4 block" data-id="element-234">😩</span>
          <h2 className="text-gold-600 font-bold tracking-widest uppercase text-sm mb-2" data-id="element-235">
            SECCIÓN 1 — EL ESPEJO DEL DOLOR
          </h2>
          <h3 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-236">
            "¿Te Reconoces en Esta Noche?"
          </h3>
        </motion.div>

        <div className="prose prose-lg prose-navy mx-auto mb-16 font-body text-navy-800" data-id="element-237">
          <p className="mb-4" data-id="element-238">Son las 10PM.</p>
          <p className="mb-4" data-id="element-239">
            Tu cuerpo pesa como si cargara el día entero — porque literalmente
            lo cargó. La casa. Los hijos que llaman pidiendo apoyo. Las facturas
            de salud que no paran. Las preocupaciones que no tienen horario.
          </p>
          <p className="mb-4" data-id="element-240">Te acuestas. Cierras los ojos.</p>
          <p className="font-bold text-xl text-navy-900" data-id="element-241">
            Y entonces... la mente acelera sin freno.
          </p>
        </div>

        {/* Thoughts Table/Cards */}
        <div className="grid gap-4 mb-16" data-id="element-242">
          {thoughts.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`grid grid-cols-1 md:grid-cols-2 gap-4 p-6 rounded-lg border ${item.isHeader ? 'bg-navy-800 text-cream-100 font-bold hidden md:grid' : 'bg-white shadow-md border-cream-200 hover:shadow-lg transition-shadow'}`} data-id="element-243">
              <div className={`${item.isHeader ? '' : 'font-serif text-lg text-navy-900 italic'}`} data-id="element-244">
                {item.isHeader ? item.thought : `💭 ${item.thought}`}
              </div>
              <div className={`${item.isHeader ? '' : 'text-navy-700'}`} data-id="element-245">
                {item.isHeader ? item.fear : `😰 ${item.fear}`}
              </div>
            </motion.div>)}
        </div>

        <div className="prose prose-lg prose-navy mx-auto font-body text-navy-800" data-id="element-246">
          <p className="mb-4" data-id="element-247">Y así pasan las horas.</p>
          <p className="mb-4" data-id="element-248">
            Das vuelta. Revisas el techo. Miras el teléfono — aunque sabes que
            no deberías.
          </p>
          <p className="mb-4" data-id="element-249">
            A las 3AM despiertas de golpe, el corazón acelerado, la mente ya en
            modo catástrofe.
          </p>
          <p className="mb-4" data-id="element-250">
            Y cuando por fin llega el amanecer... no descansaste. Solo
            sobreviviste la noche.
          </p>

          <div className="bg-gold-500/10 border-l-4 border-gold-500 p-6 my-8 rounded-r-lg" data-id="element-251">
            <p className="font-bold text-navy-900 m-0" data-id="element-252">
              Esto no es debilidad. No es la edad. No es "tu destino".
              <br data-id="element-253" />
              Es un ciclo real, con nombre, con causa — y con solución.
            </p>
          </div>
        </div>
      </div>
    </section>;
}